export interface NotificationsRes {
  id: number;
  title: string;
  body: string;
  is_read: boolean;
  params: NotificationParams | null;
  translation_params: Record<string, string | number> | null;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
  type: Type;
  user_id: number | null;
  admin_id: number | null;
  post_id: number | null;
  audience: Audience[];
  target_admin_id: number | null;
}

export enum Audience {
  Admin = 'ADMIN',
  SuperAdmin = 'SUPER_ADMIN',
  ACADEMIC_SUPERVISOR = 'ACADEMIC_SUPERVISOR',
  PROGRAM_HEAD = 'PROGRAM_HEAD',
  SystemAdmin = 'SYSTEM_ADMIN',
}

export interface NotificationParams {
  user_id?: number;
  profile_id?: number | null;
  request_id?: number;
  admin_id?: number;
}

export enum Type {
  UserRegistration = 'USER_REGISTRATION',
  CHANGE_REQUEST_RESOLVED = 'CHANGE_REQUEST_RESOLVED',
  REQUEST_SUBMISSION = 'REQUEST_SUBMISSION',
  REQUEST_ASSIGNED = 'REQUEST_ASSIGNED',
  REQUEST_APPROVAL = 'REQUEST_APPROVAL',
  CHANGE_REQUEST = 'CHANGE_REQUEST',
  POST_PUBLICATION = 'POST_PUBLICATION',
  REQUEST_REJECTED = 'REQUEST_REJECTED',
  ADMIN_CREATED = 'ADMIN_CREATED',
  ADMIN_UPDATED = 'ADMIN_UPDATED',
  USER_CREATED = 'USER_CREATED',
  USER_DISABLED = 'USER_DISABLED',
  ROLE_ASSIGNED = 'ROLE_ASSIGNED',
  ROLE_PERMISSION_ASSIGNED = 'ROLE_PERMISSION_ASSIGNED',
}
